import { Box, Group, Modal as MantineModal, ModalProps as MantineModalProps } from '@mantine/core';

import { TitleWithLeftLine } from '../TitleWithLeftLine';

type ModalProps = MantineModalProps & {
  children: React.ReactNode;
  renderFooter?: () => React.ReactNode;
  hideCloseButton?: boolean;
  onScrollContent?: (e: React.UIEvent<HTMLDivElement>) => void;
};

export function Modal({
  children,
  renderFooter,
  title,
  hideCloseButton = false,
  onScrollContent,
  ...rest
}: ModalProps) {
  return (
    <MantineModal.Root centered {...rest}>
      <MantineModal.Overlay />
      <MantineModal.Content onScroll={onScrollContent} sx={{ borderRadius: '8px' }}>
        <MantineModal.Header p={32} pt={16} pb={16}>
          <MantineModal.Title>
            {title && <TitleWithLeftLine>{title}</TitleWithLeftLine>}
          </MantineModal.Title>
          {!hideCloseButton && <MantineModal.CloseButton />}
        </MantineModal.Header>
        <MantineModal.Body px={32} py={0}>
          {children}
        </MantineModal.Body>
        <Box
          p={32}
          sx={() => ({
            position: 'sticky',
            bottom: 0,
            backgroundColor: 'white',
          })}
        >
          <Group position="center" spacing={24}>
            {renderFooter?.()}
          </Group>
        </Box>
      </MantineModal.Content>
    </MantineModal.Root>
  );
}
